<template>
  <div class="video-review-container">

    <!-- 右侧主要内容区 -->
    <div class="main-content">
      <!-- 顶部统计卡片 -->
      <div class="stats-cards">
        <el-row :gutter="24">
          <el-col :span="6">
            <div class="stat-card safe">
              <div class="stat-icon">
                <i class="el-icon-success"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.none }}</div>
                <div class="stat-label">通过审查</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card processing">
              <div class="stat-icon">
                <i class="el-icon-loading"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.runing }}</div>
                <div class="stat-label">审查中</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card danger">
              <div class="stat-icon">
                <i class="el-icon-error"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.high }}</div>
                <div class="stat-label">严重违规</div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card total">
              <div class="stat-icon">
                <i class="el-icon-pie-chart"></i>
              </div>
              <div class="stat-info">
                <div class="stat-number">{{ stats.total }}</div>
                <div class="stat-label">总审查数</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 上传区域 -->
      <div class="upload-section">
        <el-card class="upload-card" shadow="hover">
          <div slot="header" class="card-header">
            <span><i class="el-icon-upload"></i> 视频上传审查</span>
            <div class="header-buttons">
              <!-- <el-button size="small" @click="clearCompleted">清空已完成</el-button> -->
              <!-- <el-button size="small" type="primary" @click="showSettings = true">审查设置</el-button> -->
            </div>
          </div>

          <!-- 上传拖拽区 -->
          <el-upload
            ref="upload"
            class="upload-dragger"
            drag
            :action="uploadUrl"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :show-file-list="false"
            accept="video/*"
            :loading="uploading"
            :headers="uploadHeaders"
          >
            <div class="upload-content">
              <i class="el-icon-upload upload-icon"></i>
              <div class="upload-text">
                <p>将视频拖拽到此处，或<em>点击上传</em></p>
                <p class="upload-hint">支持 MP4、AVI格式，单个文件不超过500MB</p>
              </div>
            </div>
          </el-upload>

          <!-- 快捷操作 -->
          <!-- <div class="quick-actions">
            <el-button @click="pauseAllProcessing" icon="el-icon-video-pause" size="small" :disabled="!hasProcessingVideos">暂停全部</el-button>
            <el-button @click="resumeAllProcessing" icon="el-icon-video-play" size="small" :disabled="!hasPausedVideos">继续全部</el-button>
          </div> -->
        </el-card>
      </div>

      <!-- 审查任务列表 -->
      <div class="review-tasks">
        <!-- 正在处理的任务 -->
        <el-card v-if="processingTasks.length > 0" class="task-section processing-section" shadow="hover">
          <div slot="header" class="section-header">
            <span><i class="el-icon-loading rotating"></i> 正在审查 ({{ processingTasks.length }})</span>
            <el-button size="mini" @click="refreshProcessing">刷新状态</el-button>
          </div>
          
          <div class="task-grid">
            <div 
              v-for="task in processingTasks" 
              :key="task.id" 
              class="task-card processing-task"
            >
              <div class="task-video">
                <div class="video-placeholder">
                  <i class="el-icon-video-camera-solid"></i>
                </div>
                <div class="task-status processing">
                  <i class="el-icon-loading rotating"></i>
                  <span>{{ getProcessingStepText(task.step) }}</span>
                </div>
              </div>
              
              <div class="task-info">
                <div class="task-details">
                  <p><strong>文件名:</strong> {{ task.attachment ? task.attachment.filename : ''}}</p>
                  <p><strong>大小:</strong> {{ task.attachment ? task.attachment.filesize_text : 0 }}</p>
                  <p><strong>时长:</strong> {{ task.attachment ? task.attachment.video_duration_text : 0 }}</p>
                  <p><strong>分辨率:</strong> {{ task.attachment ? task.attachment.video_resolution : '未知' }} </p>
                  <p><strong>提交时间:</strong> {{ task.createtime_text }} </p>
                </div>
                
                <!-- <div class="processing-progress">
                  <div class="progress-info">
                    <span>{{ getProcessingStepText(task.step) }}</span>
                    <span class="time-info">{{ task.elapsedTime }} / 预计{{ task.estimatedTime }}</span>
                  </div>
                  <el-progress 
                    :percentage="task.progress" 
                    :stroke-width="6"
                    :show-text="false"
                    status="success"
                  ></el-progress>
                </div> -->
                
                <!-- <div class="current-analysis" v-if="task.currentFrame">
                  <p class="analysis-text">
                    <i class="el-icon-view"></i>
                    正在分析第 {{ task.currentFrame }} 帧 ({{ task.frameProgress }}%)
                  </p>
                </div> -->
              </div>
              
              <!-- <div class="task-actions">
                <el-button size="mini" @click="pauseTask(task.id)" v-if="!task.paused">暂停</el-button>
                <el-button size="mini" @click="resumeTask(task.id)" v-else type="primary">继续</el-button>
                <el-button size="mini" @click="cancelTask(task.id)" type="danger">取消</el-button>
              </div> -->
            </div>
          </div>
        </el-card>

        <!-- 排队等待的任务 -->
        <!-- <el-card v-if="queueTasks.length > 0" class="task-section queue-section" shadow="hover">
          <div slot="header" class="section-header">
            <span><i class="el-icon-clock"></i> 排队等待 ({{ queueTasks.length }})</span>
            <div>
              <el-button size="mini" @click="prioritizeAll">全部优先</el-button>
              <el-button size="mini" @click="startNextInQueue" type="primary">开始下一个</el-button>
            </div>
          </div>
          
          <div class="queue-list">
            <div 
              v-for="(task, index) in queueTasks" 
              :key="task.id"
              class="queue-item"
              :class="{ 'priority': task.priority }"
            >
              <div class="queue-number">{{ index + 1 }}</div>
              <div class="queue-info">
                <div class="file-info">
                  <i class="el-icon-video-camera-solid"></i>
                  <span class="file-name">{{ task.fileName }}</span>
                  <el-tag v-if="task.priority" size="mini" type="warning">优先</el-tag>
                </div>
                <div class="file-details">
                  {{ task.fileSize }} • {{ task.duration }} • 预计{{ task.estimatedProcessTime }}
                </div>
              </div>
              <div class="queue-actions">
                <el-button size="mini" @click="setPriority(task.id)" v-if="!task.priority">优先处理</el-button>
                <el-button size="mini" @click="removeFromQueue(task.id)" type="danger">移除</el-button>
              </div>
            </div>
          </div>
        </el-card> -->

        <!-- 已完成的任务 -->
        <el-card class="task-section completed-section" shadow="hover">
          <div slot="header" class="section-header">
            <span><i class="el-icon-document"></i> 审查结果 ({{ completedTasks.length }})</span>
            <div>
              <el-select v-model="resultFilter" size="mini" style="width: 120px; margin-right: 10px;" @change="resultList">
                <el-option label="全部结果" value="all"></el-option>
                <el-option label="通过" value="none"></el-option>
                <el-option label="违规" value="high"></el-option>
              </el-select>
              <!-- <el-button size="mini" @click="exportResults">导出结果</el-button> -->
            </div>
          </div>

          <div class="completed-list">
            <div 
              v-for="(task,index) in completedTasks" 
              :key="task.id"
              class="completed-task"
            >
              <div class="task-preview">
                <div class="video-thumbnail">
                  <img :src="task.attachment ? task.attachment.video_thumb : ''" />
                  <div class="play-overlay" @click="playVideo(task)">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
                <div class="task-basic-info">
                  <h4>{{ task.attachment ? task.attachment.filename : '' }}</h4>
                  <div class="basic-details">
                    <span>{{ task.attachment ? task.attachment.filesize_text : '' }}</span>
                    <span>{{ task.attachment ? task.attachment.video_duration_text : 0 }}</span>
                    <span>{{ task.attachment ? task.attachment.video_resolution : '未知' }}</span>
                  </div>
                  <div class="completion-time">
                    完成时间: {{ task.updatetime_text }}
                  </div>
                </div>
              </div>

              <div class="task-result">
                <div class="result-status">
                  <el-tag 
                    :type="getResultTagType(task.riskLevel)" 
                    size="medium"
                  >
                    {{ getResultStatusText(task.riskLevel) }}
                  </el-tag>
                  <!-- <div class="confidence-score">
                    总体评分: {{ task.result.overallScore }}/100
                  </div> -->
                </div>

                <!-- 安全视频 -->
                <div v-if="task.riskLevel === 'none'" class="safe-summary">
                  <div class="safe-icon">
                    <i class="el-icon-success"></i>
                    <span>该视频内容健康，未发现违规内容</span>
                  </div>
                  <!-- <div class="analysis-summary">
                    <div class="summary-item">
                      <span>分析帧数:</span>
                      <span>11</span>
                    </div>
                    <div class="summary-item">
                      <span>音频分析:</span>
                      <span>11</span>
                    </div>
                  </div> -->
                </div>

                <!-- 违规视频 -->
                <div v-else class="violation-summary">
                  <div class="violations-header">
                    <i class="el-icon-warning-outline"></i>
                    <span>发现 {{ task.FrameResult.FrameNum }} 项违规内容</span>
                  </div>
                  
                  <div class="violations-preview">
                    <div 
                      v-for="(violation, vIndex) in task.FrameResult.Frames" 
                      :key="vIndex"
                      class="violation-preview-item"
                    >
                      <el-tag 
                        :type="getViolationTagType(violation.RiskLevel)" 
                        size="mini"
                      >
                        {{ getResultStatusText(task.riskLevel) }}
                      </el-tag>
                      <span class="violation-time">视频第{{ violation.Offset }}秒</span>

                      <div v-for="(res,resIndex) in violation.Results" :key="resIndex">
                        <el-tag  
                          size="mini"
                          type="warning"
                        >
                          {{ res.Result[0].Description }}
                        </el-tag>
                        <span class="violation-confidence">置信度：{{ res.Result[0].Confidence }}%</span>
                      </div>
                      
                    </div>
                    <!-- <div v-if="task.FrameResult.Frames.length > 3" class="more-violations">
                      还有 {{ task.FrameResult.Frames.length - 3 }} 项违规...
                    </div> -->
                  </div>
                </div>

                <!-- 时间线预览 -->
                <div class="timeline-preview">
                  <div class="timeline-header">
                    <span>审查时间线</span>
                    <span class="timeline-duration">{{ task.attachment ? task.attachment.video_duration_text : 0 }}</span>
                  </div>
                  <div class="timeline-bar">
                    <div 
                      v-for="segment in task.result.timeline" 
                      :key="segment.id"
                      class="timeline-segment"
                      :class="segment.status"
                      :style="{ width: segment.percentage + '%' }"
                      :title="`${segment.startTime}-${segment.endTime}: ${segment.status}`"
                    ></div>
                  </div>
                  <div class="timeline-legend">
                    <span class="legend-item safe"><i></i>安全</span>
                    <span class="legend-item warning"><i></i>警告</span>
                    <span class="legend-item danger"><i></i>违规</span>
                  </div>
                </div>
              </div>

              <div class="task-detail-actions">
                <!-- <el-button size="small" @click="viewDetailReport(task)">
                  <i class="el-icon-document"></i> 详细报告
                </el-button>
                <el-button size="small" @click="downloadReport(task)">
                  <i class="el-icon-download"></i> 下载报告
                </el-button>
                <el-button size="small" @click="reprocessVideo(task)">
                  <i class="el-icon-refresh"></i> 重新审查
                </el-button> -->
                <el-button size="small" @click="deleteTask(task.id)" type="danger">
                  <i class="el-icon-delete"></i> 删除
                </el-button>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 审查设置弹窗 -->
    <el-dialog
      title="视频审查设置"
      :visible.sync="showSettings"
      width="600px"
    >
      <el-form :model="settings" label-width="120px">
        <el-form-item label="审查类型">
          <el-checkbox-group v-model="settings.reviewTypes">
            <el-checkbox label="违法违规">违法违规内容</el-checkbox>
            <el-checkbox label="暴力血腥">暴力血腥内容</el-checkbox>
            <el-checkbox label="色情低俗">色情低俗内容</el-checkbox>
            <el-checkbox label="恶心内容">恶心不适内容</el-checkbox>
            <el-checkbox label="广告推广">广告推广内容</el-checkbox>
            <el-checkbox label="音频检测">音频内容检测</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        
        <el-form-item label="审查精度">
          <el-radio-group v-model="settings.precision">
            <el-radio label="fast">快速审查 (关键帧)</el-radio>
            <el-radio label="standard">标准审查 (每秒1帧)</el-radio>
            <el-radio label="high">高精度审查 (每秒3帧)</el-radio>
            <el-radio label="ultra">超高精度 (全帧分析)</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="并发处理数">
          <el-slider
            v-model="settings.concurrentTasks"
            :min="1"
            :max="5"
            show-input
            :step="1"
            style="margin-right: 20px;"
          ></el-slider>
        </el-form-item>
        
        <el-form-item label="置信度阈值">
          <el-slider
            v-model="settings.confidenceThreshold"
            :min="50"
            :max="95"
            show-input
            style="margin-right: 20px;"
          ></el-slider>
        </el-form-item>
        
        <el-form-item label="自动处理">
          <el-switch
            v-model="settings.autoProcess"
            active-text="开启自动处理队列"
            inactive-text="手动开始处理"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSettings = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings">保存设置</el-button>
      </span>
    </el-dialog>

    <!-- 详细报告弹窗 -->
    <el-dialog
      title="详细审查报告"
      :visible.sync="showDetailReport"
      width="80%"
      class="detail-report-dialog"
    >
      <div v-if="currentDetailTask" class="detail-report-content">
        <!-- 报告内容会在这里展示 -->
        <div class="report-header">
          <h3>{{ currentDetailTask.fileName }}</h3>
          <div class="report-meta">
            <span>审查时间: {{ currentDetailTask.completedTime }}</span>
            <span>处理耗时: {{ currentDetailTask.processingDuration }}</span>
            <span>AI模型: {{ currentDetailTask.aiModel }}</span>
          </div>
        </div>
        <!-- 这里可以添加更详细的报告内容 -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailReport = false">关 闭</el-button>
        <el-button type="primary" @click="downloadCurrentReport">下载报告</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from '@/utils/request'
export default {
  name: 'VideoReview',
  data() {
    return {
      imgUrl:baseURL,
      uploadUrl: baseURL + '/api/common/upload', // 后端API地址
      uploadHeaders:{
        "Token" : localStorage.getItem('token')
      },
      showSettings: false,
      showDetailReport: false,
      currentDetailTask: null,
      resultFilter: 'all',
      uploading: false,
      
      // 统计数据
      stats: {
        none: 0,
        runing: 0,
        high: 0,
        total: 0
      },
      
      // 审查设置
      settings: {
        reviewTypes: ['违法违规', '暴力血腥', '色情低俗'],
        precision: 'standard',
        concurrentTasks: 2,
        confidenceThreshold: 75,
        autoProcess: true
      },
      
      // 正在处理的任务
      processingTasks: [],
      
      // 排队任务
      queueTasks: [
        {
          id: 'queue_001',
          fileName: 'waiting_video_1.mp4',
          fileSize: '234.1MB',
          duration: '08:45',
          estimatedProcessTime: '04:20',
          priority: true
        },
        {
          id: 'queue_002',
          fileName: 'waiting_video_2.avi',
          fileSize: '156.7MB',
          duration: '06:12',
          estimatedProcessTime: '03:10',
          priority: false
        }
      ],
      
      // 已完成任务
      completedTasks: [
       
      ]
    }
  },
  
  computed: {
    hasProcessingVideos() {
      return this.processingTasks.some(task => !task.paused);
    },
    
    hasPausedVideos() {
      return this.processingTasks.some(task => task.paused);
    },

  },
  created(){
    //审查中
    this.selectTotal()
    this.getList()
    this.videoExamineRunList()
  },
  methods: {
    resultList(){
      this.completedTasks = [];
      this.getList()
    },
    async selectTotal(){
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/videoExamineTotal', {})
        if(res.code == 1){
          Object.assign(this.stats, res.data.count)
        }
      } catch (err) {
        console.error('获取失败:', err)
        this.$message.error(err.message || '数据获取失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(seconds) {
      const h = String(Math.floor(seconds / 3600)).padStart(2, '0');
      const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      const s = String(seconds % 60).padStart(2, '0');
      return `${h}:${m}:${s}`;
    },
    async videoExamineRunList(){
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/videoExamineRunList', {})
        if(res.code == 1){
          // 用 Vue.set 或解构确保响应式更新
          this.$set(this, 'processingTasks', res.data.list.data)
          this.$nextTick(() => {
            
          })
        }
      } catch (err) {
        console.error('获取失败:', err)
        this.$message.error(err.message || '数据获取失败')
      } finally {
        this.loading = false
      }
    },
    async getList(){
      try {
        // 调用后端接口
        const res = await this.$api.post('/api/examine/videoExamineList', {page:this.page,riskLevel:this.resultFilter})
        if(res.code == 1){
          // 用 Vue.set 或解构确保响应式更新
          this.$set(this, 'completedTasks', res.data.list.data)
          this.$nextTick(() => {
            
          })
        }
      } catch (err) {
        console.error('获取失败:', err)
        this.$message.error(err.message || '数据获取失败')
      } finally {
        this.loading = false
      }
    },
    // 文件上传前验证
    beforeUpload(file) {
      const isVideo = file.type.startsWith('video/');
      const isLt500M = file.size / 1024 / 1024 < 500;

      if (!isVideo) {
        this.$message.error('只能上传视频文件!');
        return false;
      }
      if (!isLt500M) {
        this.$message.error('视频大小不能超过 500MB!');
        return false;
      }

      return true;
    },

    // 上传成功回调
    async handleUploadSuccess(response) {
      if (response.code == 1) {
          const res = await this.$api.post('/api/examine/addVideoExamine', {videoFullUrl:response.data.fullurl,videoUrl:response.data.url,file_id:response.data.file_id})
          if(res.code == 1){
             // 添加到处理队列或直接开始处理
             this.processingTasks.push(res.data.data);
            
            this.updateStats();
            this.$message.success('视频上传成功，已加入审查队列！');
          }else{
            this.$message.error(response.msg || '上传失败！');
          }
      } else {
        this.$message.error(response.msg || '上传失败！');
      }
    },

    // 上传失败回调
    handleUploadError(error) {
      this.$message.error('上传失败，请重试！');
    },

    // 获取处理步骤文本
    getProcessingStepText(step) {
      const steps = {
        'uploading': '上传中',
        'extracting': '提取帧数据',
        'analyzing': '智能分析',
        'finalizing': '生成报告'
      };
      return steps[step] || '处理中';
    },

    // 获取结果标签类型
    getResultTagType(status) {
      const types = {
        'none': 'success',
        'medium': 'warning',
        'low': 'warning',
        'high': 'danger'
      };
      return types[status] || 'info';
    },

    // 获取结果状态文本
    getResultStatusText(status) {
      const texts = {
        'none': '通过审查',
        'high': '高风险违规内容',
        'medium': '中风险违规内容',
        'low': '低风险违规内容'
      };
      return texts[status] || '未知';
    },

    // 获取违规标签类型
    getViolationTagType(severity) {
      const types = {
        'low': 'warning',
        'medium': 'warning',
        'high': 'danger'
      };
      return types[severity] || 'info';
    },

    // 任务控制
    pauseTask(taskId) {
      const task = this.processingTasks.find(t => t.id === taskId);
      if (task) {
        task.paused = true;
        this.$message.success('任务已暂停');
      }
    },

    resumeTask(taskId) {
      const task = this.processingTasks.find(t => t.id === taskId);
      if (task) {
        task.paused = false;
        this.$message.success('任务已继续');
      }
    },

    cancelTask(taskId) {
      this.$confirm('确定取消这个审查任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.processingTasks = this.processingTasks.filter(t => t.id !== taskId);
        this.updateStats();
        this.$message.success('任务已取消');
      });
    },

    // 批量操作
    pauseAllProcessing() {
      this.processingTasks.forEach(task => {
        if (!task.paused) task.paused = true;
      });
      this.$message.success('已暂停所有处理任务');
    },

    resumeAllProcessing() {
      this.processingTasks.forEach(task => {
        if (task.paused) task.paused = false;
      });
      this.$message.success('已继续所有处理任务');
    },

    refreshProcessing() {
      // 刷新处理中任务的状态
      this.videoExamineRunList();
      this.getList();
      this.$message.success('状态已刷新');
    },

    // 队列管理
    setPriority(taskId) {
      const task = this.queueTasks.find(t => t.id === taskId);
      if (task) {
        task.priority = true;
        // 将优先任务移到队列前面
        this.queueTasks = [
          ...this.queueTasks.filter(t => t.priority),
          ...this.queueTasks.filter(t => !t.priority)
        ];
        this.$message.success('已设置为优先处理');
      }
    },

    prioritizeAll() {
      this.queueTasks.forEach(task => task.priority = true);
      this.$message.success('已将所有任务设置为优先');
    },

    startNextInQueue() {
      if (this.queueTasks.length > 0 && this.processingTasks.length < this.settings.concurrentTasks) {
        const nextTask = this.queueTasks.shift();
        // 转换为处理任务格式
        const processingTask = {
          id: nextTask.id,
          fileName: nextTask.fileName,
          fileSize: nextTask.fileSize,
          duration: nextTask.duration,
          resolution: '1920x1080', // 实际应该从视频信息获取
          step: 'extracting',
          progress: 0,
          elapsedTime: '00:00',
          estimatedTime: nextTask.estimatedProcessTime,
          currentFrame: 0,
          frameProgress: 0,
          paused: false
        };
        this.processingTasks.push(processingTask);
        this.updateStats();
        this.$message.success('已开始处理下一个任务');
      } else if (this.processingTasks.length >= this.settings.concurrentTasks) {
        this.$message.warning('当前并发处理任务已达上限');
      } else {
        this.$message.warning('队列中没有待处理任务');
      }
    },

    removeFromQueue(taskId) {
      this.$confirm('确定从队列中移除这个任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.queueTasks = this.queueTasks.filter(t => t.id !== taskId);
        this.updateStats();
        this.$message.success('已从队列中移除');
      });
    },

    // 结果操作
    playVideo(task) {
      this.$message.info('视频播放功能开发中...');
    },

    viewDetailReport(task) {
      this.currentDetailTask = task;
      this.showDetailReport = true;
    },

    downloadReport(task) {
      this.$message.success('报告下载中...');
    },

    downloadCurrentReport() {
      this.$message.success('详细报告下载中...');
    },

    reviewVideo(task) {
      this.$message.info('跳转到人工复审界面...');
    },

    reprocessVideo(task) {
      this.$confirm('确定重新审查这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 将任务重新加入处理队列
        const reprocessTask = {
          id: 'reproc_' + Date.now(),
          fileName: task.fileName,
          fileSize: task.fileSize,
          duration: task.duration,
          estimatedProcessTime: '03:00',
          priority: false
        };
        this.queueTasks.unshift(reprocessTask);
        this.updateStats();
        this.$message.success('已重新加入审查队列');
      });
    },

     deleteTask(taskId) {
      this.$confirm('确定删除这个审查结果吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$api.post('/api/examine/delVideoExamine', {id:taskId})
        if(res.code == 1){
          this.completedTasks = this.completedTasks.filter(t => t.id !== taskId);
          this.updateStats();
        }
        this.$message.success(res.msg);
      }).catch(() => {
        
      });
    },

    // 其他操作
    selectFiles() {
      this.$refs.upload.$el.querySelector('input').click();
    },

    clearCompleted() {
      this.$confirm('确定清空所有已完成的任务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.completedTasks = [];
        this.updateStats();
        this.$message.success('已清空所有完成任务');
      });
    },

    exportResults() {
      this.$message.success('结果导出中...');
    },

    saveSettings() {
      this.$message.success('设置保存成功！');
      this.showSettings = false;
    },

    // 更新统计数据
    updateStats() {
      this.stats.runing = this.processingTasks.length;
      this.stats.none = this.completedTasks.filter(t => t.result.status === 'none').length;
      this.stats.high = this.completedTasks.filter(t => t.result.status === 'high').length;
      this.stats.total = this.completedTasks.length + this.processingTasks.length + this.queueTasks.length;
    }
  },
  
  mounted() {
    // 模拟处理进度更新
    // setInterval(() => {
    //   this.processingTasks.forEach(task => {
    //     if (!task.paused && task.progress < 100) {
    //       task.progress = Math.min(100, task.progress + Math.random() * 5);
    //       if (task.currentFrame) {
    //         task.currentFrame += Math.floor(Math.random() * 10);
    //         task.frameProgress = task.progress;
    //       }
          
    //       // 更新已用时间
    //       const elapsed = parseInt(task.elapsedTime.split(':')[0]) * 60 + parseInt(task.elapsedTime.split(':')[1]);
    //       const newElapsed = elapsed + 1;
    //       task.elapsedTime = Math.floor(newElapsed / 60).toString().padStart(2, '0') + ':' + 
    //                        (newElapsed % 60).toString().padStart(2, '0');
          
    //       // 如果完成，移动到已完成列表
    //       if (task.progress >= 100) {
    //         // 这里应该调用API获取实际结果，现在用模拟数据
    //         const completedTask = {
    //           id: task.id,
    //           fileName: task.filename,
    //           fileSize: task.filesize,
    //           duration: task.duration,
    //           resolution: task.resolution,
    //           thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjkwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNkZGQiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+5paw5a6M5oiQPC90ZXh0Pjwvc3ZnPg==',
    //           completedTime: new Date().toLocaleString(),
    //           result: {
    //             status: Math.random() > 0.7 ? 'safe' : 'violation',
    //             overallScore: Math.floor(Math.random() * 40) + 60,
    //             analyzedFrames: Math.floor(Math.random() * 2000) + 500,
    //             audioAnalysis: '通过',
    //             violations: [],
    //             timeline: [
    //               { id: 1, startTime: '00:00', endTime: task.duration, status: 'safe', percentage: 100 }
    //             ]
    //           },
    //           processingDuration: task.elapsedTime,
    //           aiModel: 'VideoScan Pro v3.2'
    //         };
            
    //         this.completedTasks.unshift(completedTask);
    //         this.processingTasks = this.processingTasks.filter(t => t.id !== task.id);
    //         this.updateStats();
    //         this.$message.success(`视频 ${task.fileName} 审查完成！`);
    //       }
    //     }
    //   });
    // }, 2000); // 每2秒更新一次进度
  }
}
</script>

<style scoped>
.video-review-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 侧边栏样式 */
.sidebar {
  width: 250px;
  background-color: #2c3e50;
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
}

.logo-section {
  padding: 20px;
  text-align: center;
  color: #ecf0f1;
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #34495e;
}

.logo-section i {
  font-size: 24px;
  margin-right: 8px;
  color: #e74c3c;
}

.sidebar-menu {
  border: none;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
}

/* 主内容区 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 统计卡片 */
.stats-cards {
  margin-bottom: 20px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  min-height: 80px;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 20px;
}

.stat-card.safe .stat-icon {
  background: #e8f5e8;
  color: #67c23a;
}

.stat-card.processing .stat-icon {
  background: #e6f7ff;
  color: #409eff;
}

.stat-card.processing .stat-icon i {
  animation: rotating 2s linear infinite;
}

.stat-card.warning .stat-icon {
  background: #fdf6ec;
  color: #e6a23c;
}

.stat-card.danger .stat-icon {
  background: #fef0f0;
  color: #f56c6c;
}

.stat-card.queue .stat-icon {
  background: #f4f4f5;
  color: #909399;
}

.stat-card.total .stat-icon {
  background: #e6f7ff;
  color: #409eff;
}

.stat-info {
  flex: 1;
}

.stat-number {
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}

.stat-label {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

/* 上传区域 */
.upload-section {
  margin-bottom: 20px;
}

.upload-card {
  background: white;
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-buttons .el-button {
  margin-left: 8px;
}

.upload-dragger {
  width: 100%;
  text-align: center;
}

.upload-content {
  text-align: center;
  padding: 0;
}

.upload-icon {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

.upload-text p {
  margin: 8px 0;
}

.upload-hint {
  font-size: 12px;
  color: #909399;
}

.quick-actions {
  text-align: center;
  margin-top: 20px;
}

.quick-actions .el-button {
  margin: 0 5px;
}

/* 任务区域 */
.review-tasks {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.task-section {
  background: white;
  border-radius: 8px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.rotating {
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 处理中任务 */
.processing-section {
  border-left: 4px solid #409eff;
}

.task-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.task-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 15px;
  background: #fafbfc;
}

.processing-task {
  background: #f0f9ff;
  border-color: #b3d8ff;
}

.task-video {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.video-placeholder {
  width: 60px;
  height: 45px;
  background: #e9ecef;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-size: 12px;
  text-align: center;
}

.video-placeholder i {
  font-size: 16px;
  color: #6c757d;
  margin-bottom: 2px;
}

.task-status {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
}

.task-status.processing {
  color: #409eff;
}

.task-info {
  margin-bottom: 15px;
}

.task-details {
  font-size: 12px;
  color: #606266;
  margin-bottom: 10px;
}

.task-details p {
  margin: 2px 0;
}

.processing-progress {
  margin-bottom: 10px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  font-size: 12px;
  color: #606266;
}

.time-info {
  font-size: 11px;
  color: #909399;
}

.current-analysis {
  background: #e6f7ff;
  padding: 8px 10px;
  border-radius: 4px;
  border-left: 3px solid #409eff;
}

.analysis-text {
  font-size: 12px;
  color: #409eff;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.task-actions {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.task-detail-actions .el-button {
  padding: 6px 12px;
  font-size: 13px;
}

/* 设置对话框 */
.dialog-footer {
  text-align: center;
}

.detail-report-dialog {
  max-height: 80vh;
}

.detail-report-content {
  max-height: 60vh;
  overflow-y: auto;
}

.report-header h3 {
  margin: 0 0 10px 0;
  color: #303133;
}

.report-meta {
  display: flex;
  gap: 20px;
  font-size: 12px;
  color: #909399;
  margin-bottom: 20px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .stats-cards .el-col {
    margin-bottom: 10px;
  }
  
  .task-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .video-review-container {
    flex-direction: column;
  }
  
  .sidebar {
    width: 100%;
    height: auto;
  }
  
  .main-content {
    padding: 10px;
  }
  
  .task-preview {
    flex-direction: column;
  }
  
  .video-thumbnail {
    width: 100%;
    height: 200px;
    margin-right: 0;
    margin-bottom: 10px;
  }
  
  .task-detail-actions {
    justify-content: center;
  }
  
  .basic-details {
    flex-direction: column;
    gap: 5px;
  }
  
  .analysis-summary {
    grid-template-columns: 1fr;
  }
}

/* 动画效果 */
.completed-task {
  animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.task-card {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Element UI 样式覆盖 */
.el-card {
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.el-card__header {
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.el-upload-dragger {
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  background-color: #fafafa;
  transition: all 0.3s;
}

.el-upload-dragger:hover {
  border-color: #409eff;
}

.el-progress-bar__outer {
  border-radius: 100px;
}

.el-progress-bar__inner {
  border-radius: 100px;
}

.el-tag {
  border: none;
  font-weight: 500;
}

.el-select {
  width: 100%;
}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.el-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.el-slider {
  margin-right: 20px;
}

/* 加载和过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active {
  transition: all 0.3s ease;
}

.slide-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-enter, .slide-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 特殊状态样式 */
.processing-task {
  position: relative;
  overflow: hidden;
}

.processing-task::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #409eff, transparent);
  animation: loading 2s infinite;
}

@keyframes loading {
  0% { left: -100%; }
  100% { left: 100%; }
}

.queue-item.priority {
  position: relative;
}

.queue-item.priority::after {
  content: '优先';
  position: absolute;
  top: 5px;
  right: 5px;
  background: #e6a23c;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
}

/* 数据为空时的样式 */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
  display: block;
}

.empty-state p {
  font-size: 14px;
  line-height: 1.6;
}

/* 状态指示器 */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.status-indicator.processing {
  background: #e6f7ff;
  color: #409eff;
}

.status-indicator.safe {
  background: #e8f5e8;
  color: #67c23a;
}

.status-indicator.violation {
  background: #fef0f0;
  color: #f56c6c;
}

.status-indicator.warning {
  background: #fdf6ec;
  color: #e6a23c;
}

/* 高亮效果 */
.highlight {
  background: #fff3cd;
  padding: 2px 4px;
  border-radius: 3px;
  border: 1px solid #ffeaa7;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

.task-actions .el-button {
  padding: 5px 10px;
  font-size: 12px;
}

/* 队列区域 */
.queue-section {
  border-left: 4px solid #909399;
}

.queue-list {
  padding: 15px 0;
}

.queue-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f2f5;
  transition: all 0.3s;
}

.queue-item:hover {
  background: #fafbfc;
  margin: 0 -15px;
  padding-left: 15px;
  padding-right: 15px;
}

.queue-item.priority {
  background: #fff7e6;
  border-left: 3px solid #e6a23c;
  padding-left: 12px;
}

.queue-number {
  width: 30px;
  height: 30px;
  background: #f0f2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  color: #606266;
  margin-right: 15px;
}

.queue-item.priority .queue-number {
  background: #e6a23c;
  color: white;
}

.queue-info {
  flex: 1;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.file-info i {
  color: #909399;
}

.file-name {
  font-weight: 500;
  color: #303133;
}

.file-details {
  font-size: 12px;
  color: #909399;
}

.queue-actions {
  display: flex;
  gap: 5px;
}

.queue-actions .el-button {
  padding: 4px 8px;
  font-size: 11px;
}

/* 完成任务区域 */
.completed-section {
  border-left: 4px solid #67c23a;
}

.completed-list {
  padding: 15px 0;
}

.completed-task {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.3s;
}

.completed-task:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.task-preview {
  display: flex;
  padding: 15px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.video-thumbnail {
  position: relative;
  width: 120px;
  height: 90px;
  margin-right: 15px;
  border-radius: 6px;
  overflow: hidden;
}

.video-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s;
  cursor: pointer;
}

.video-thumbnail:hover .play-overlay {
  opacity: 1;
}

.play-overlay i {
  font-size: 24px;
  color: white;
}

.task-basic-info {
  flex: 1;
}

.task-basic-info h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #303133;
}

.basic-details {
  display: flex;
  gap: 15px;
  margin-bottom: 8px;
  font-size: 12px;
  color: #606266;
}

.completion-time {
  font-size: 11px;
  color: #909399;
}

.task-result {
  padding: 15px;
}

.result-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.confidence-score {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

/* 安全结果 */
.safe-summary {
  background: #f0f9ff;
  border: 1px solid #b3d8ff;
  border-radius: 6px;
  padding: 15px;
}

.safe-icon {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #67c23a;
  font-weight: 500;
}

.safe-icon i {
  font-size: 18px;
}

.analysis-summary {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #606266;
}

/* 违规结果 */
.violation-summary {
  background: #fef0f0;
  border: 1px solid #fbc4c4;
  border-radius: 6px;
  padding: 15px;
}

.violations-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #f56c6c;
  font-weight: 500;
}

.violations-preview {
  margin-bottom: 10px;
}

.violation-preview-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 5px;
  font-size: 12px;
}

.violation-time {
  color: #606266;
}

.violation-confidence {
  font-weight: 500;
  color: #f56c6c;
}

.more-violations {
  font-size: 12px;
  color: #909399;
  text-align: center;
  padding: 5px;
  background: #fafafa;
  border-radius: 4px;
}

/* 时间线预览 */
.timeline-preview {
  margin-top: 15px;
  padding: 15px;
  background: #fafbfc;
  border-radius: 6px;
  border: 1px solid #ebeef5;
}

.timeline-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #303133;
}

.timeline-duration {
  font-size: 12px;
  color: #909399;
}

.timeline-bar {
  height: 6px;
  background: #f0f2f5;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  margin-bottom: 8px;
}

.timeline-segment {
  height: 100%;
  transition: all 0.3s;
}

.timeline-segment:hover {
  opacity: 0.8;
}

.timeline-segment.safe {
  background: #67c23a;
}

.timeline-segment.warning {
  background: #e6a23c;
}

.timeline-segment.danger {
  background: #f56c6c;
}

.timeline-legend {
  display: flex;
  gap: 15px;
  font-size: 11px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #606266;
}

.legend-item i {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.legend-item.safe i {
  background: #67c23a;
}

.legend-item.warning i {
  background: #e6a23c;
}

.legend-item.danger i {
  background: #f56c6c;
}

/* 操作按钮 */
.task-detail-actions {
  padding: 15px;
  background: #fafbfc;
  border-top: 1px solid #ebeef5;
  display: flex;
  gap: 8px;
  justify-content: flex;
}
</style>